import { WellTypeIcon } from 'src/shared/constants/well-type-icon';
import { addGOplanPrefix } from 'src/shared/utils/prefixes';

import { Dnd } from '../../../features/editing/types';
import { Range } from '../../../layers/model';
import { NeighborScheme } from '../../../shared/entities/neighbor-scheme';
import { RawWell, WithKey } from '../../../types';
import { PadRigOperation } from '../../drilling-rigs-chart/entities';

export class ConflictRigOperation implements Dnd.Draggable<ConflictRigOperation, PadRigOperation>, WithKey {
  readonly uniqueCreationKey: string | null;
  readonly neighborScheme = new NeighborScheme({ neighbor: undefined }, { neighbor: undefined });
  readonly data: RawWell;
  readonly color: string;
  readonly title: string;
  readonly attributes: string[];
  readonly wellTypeIcon?: WellTypeIcon;
  readonly rigOperationIndex: number | null;
  readonly parentRigTitle: string;

  constructor(
    uniqueCreationKey: string | null,
    data: RawWell,
    title: string,
    parentRigTitle: string,
    rigOperationIndex: number | null,
    attributes: string[],
    color: string,
    wellTypeIcon?: WellTypeIcon,
  ) {
    this.uniqueCreationKey = uniqueCreationKey;
    this.data = data;
    this.color = color;
    this.attributes = attributes;
    this.title = title;
    this.rigOperationIndex = rigOperationIndex;
    this.wellTypeIcon = wellTypeIcon;
    this.parentRigTitle = parentRigTitle;
  }

  get x(): Range<number> | null {
    return null;
  }

  getFieldValue(fieldName: string): unknown {
    if (fieldName in this.data) {
      return this.data[fieldName];
    }
  }

  getRigId(): number | null {
    const rigIdAttr = addGOplanPrefix('RigOperation.rigId');

    if (rigIdAttr in this.data) {
      const rigId = Number(this.data[rigIdAttr]);

      return !Number.isNaN(rigId) ? rigId : null;
    }

    return null;
  }

  clone(): ConflictRigOperation {
    return new ConflictRigOperation(
      this.uniqueCreationKey,
      this.data,
      this.title,
      this.parentRigTitle,
      this.rigOperationIndex,
      this.attributes,
      this.color,
    );
  }

  getKey(prefix?: string): string {
    if (prefix) {
      return `${prefix}-conflict-well-${this.uniqueCreationKey}`;
    }

    return `conflict-well-${this.uniqueCreationKey}`;
  }
}
